function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "38.928,431.416 27.616,420.104 146.56,301.176 327.44,399.848 470.784,288.376 480.592,301 328.976,418.904  149.392,320.952 "
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgStatsLineChartSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.48 512.48",
    style: {
      enableBackground: "new 0 0 512.48 512.48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M267.584,274.856v-28.32c-16.256-0.288-33.056-5.328-42.88-12.336l6.72-18.784 c10.096,6.72,24.672,12.048,40.352,12.048c19.904,0,33.36-11.488,33.36-27.472c0-15.408-10.944-24.944-31.664-33.344 c-28.592-11.216-46.256-24.112-46.256-48.48c0-23.264,16.544-40.928,42.336-45.12v-28.32h17.376v27.184 c16.816,0.56,28.32,5.04,36.432,9.808l-7.024,18.528c-5.872-3.376-17.376-9.536-35.312-9.536 c-21.584,0-29.696,12.896-29.696,24.096c0,14.576,10.368,21.856,34.752,31.952c28.88,11.776,43.456,26.336,43.456,51.296 c0,22.144-15.424,42.88-44.304,47.648v29.152H267.584z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#32BEA6"
    },
    cx: 479.216,
    cy: 294.68,
    r: 33.264
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#32BEA6"
    },
    cx: 33.264,
    cy: 434.488,
    r: 33.264
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#32BEA6"
    },
    cx: 145.36,
    cy: 312.056,
    r: 33.264
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#32BEA6"
    },
    cx: 328.208,
    cy: 407.304,
    r: 33.264
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsLineChartSvgrepoCom);
export default __webpack_public_path__ + "static/media/stats-line-chart-svgrepo-com.e8b6a243.svg";
export { ForwardRef as ReactComponent };